import {useCallback, useEffect, useState} from 'react';

const useFetcher = (action, initialData) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(initialData);
  const [refetch, setRefetch] = useState({redo: false});

  const toggleRefetch = useCallback(() => {
    setRefetch({redo: true});
  }, []);

  useEffect(() => {
    let unmounted = false;

    async function loadData() {
      try {
        if (!action) {
          return;
        }
        setLoading(true);
        const actionData = await action();
        console.log(
          '-------------------------usefetcher--------------------------',
        );
        console.log(actionData);
        if (!unmounted) {
          setData(actionData);
          setError(null);
        }
      } catch (error) {
        if (unmounted) {
          return;
        }
        setError(error);
      } finally {
        if (!unmounted) {
          setLoading(false);
        }
      }
    }
    loadData();
    return function cancel() {
      unmounted = true;
    };
  }, [refetch]);

  return {
    data,
    error,
    loading,
    refetch: toggleRefetch
  };
};

export default useFetcher;
